import axios from 'axios'
import queryString from 'query-string'
import store from './store'
import { notLoggedIn } from './store/actions/user'

axios.defaults.baseURL = window.URL_API


function requestInterceptor(request) {
    request.headers.Auth = getCookie('authorization')
    // if(store.getState().login.authorization)
    //     request.headers.Auth = store.getState().login.authorization
        
    if (request.data && request.data.constructor === FormData) {
        request.headers['Content-Type'] = 'multipart/form-data'
    }

    if (request.data && request.data.constructor === Object) {
        request.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        request.data = queryString.stringify(request.data)
    }

    return request
}


function successInterceptor(response) {
    if(response.data.errors) {
        if(response.data.errors[0].parameter_name === 'Authorization') {
            localStorage.removeItem('authorization')
            store.dispatch(notLoggedIn())
        }
    }

    return response.data
}

function errorInterceptor(error) {
    console.log("Error:")
    console.error(error)
}

axios.interceptors
    .request.use(requestInterceptor)

axios.interceptors
    .response
    .use(successInterceptor, errorInterceptor)



function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}


// WEBPACK FOOTER //
// ./src/axios.config.js